<template>
  <Section v-if="showWholeComponent" class="featuredBuyersSearchingMap" :title="computedTitle" :subtitle="computedSubtitle" iconClass="pen-icon">
    <template slot="icon">
      <PenIcon />
    </template>
    <template slot="content">
      <VSectionLoader v-if="loadingBloopObj" class="col-22 offset-2 mt-5"/>
      <b-row v-else>
        <b-col cols="24" class="map-background">
          <b-row class="d-flex align-items-stretch">
            <b-col cols="22" offset="1" lg="24" offset-lg="0" class="align-items-center">
              <div class="buyermap">
                <BloopBloop v-once />
              </div>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </template>
  </Section>
</template>

<script>
import Section from '@/components/shared/Section'
import BloopBloop from '@/components/generic/BloopBloop'

import PenIcon from '@/../public/svg/PenIcon.svg'

import { mapState } from 'vuex'

export default {
  name: 'featured-buyers-searching',
  components: {
    Section,
    PenIcon,
    BloopBloop,
  },
  computed: {
    ...mapState('buyers', [
      'loadingBloopObj',
      'bloopObj'
    ]),
    computedTitle() {
      return "Buyers Searching Right Now"
    },
    computedSubtitle () {
      return "Through our national network, we have access to buyers searching all over the country."
    },
    showWholeComponent() {
      return this.loadingBloopObj || this.bloopObj.length > 0
    },
  }
}
</script>

<style lang="scss" >
@import '@/styles/_custom-variables.scss';
@import '@/styles/_custom-mixins.scss';

.featuredBuyersSearchingMap {
  .map-background {
    background-color: $primary;
  }
}

</style>
